<div class="info-banner" [ngClass]="type" *transloco="let t">
  <!-- Demo -->
  <div class="type-wrapper demo" *ngIf="type === 'demo'">
    <span>{{ t('shared/demoKindergarten') }}</span>
  </div>
  <!-- Trial -->
  <div class="type-wrapper trial" *ngIf="type === 'trial'">
    <i class="material-symbols-rounded filled">alarm</i>
    <ng-container *ngIf="hasTestKit">
      <span [innerHtml]="t('shared/trialEnds', { daysLeft: daysLeft || '-' })"></span>
      <span
        *ngIf="authService.loggedUser.teacher?.isDirector() || authService.loggedUser.teacher?.isManager()"
        class="link"
        (click)="handleRedirectToPriceList()"
        >{{ t('shared/goToFullVersion') }}</span
      >
    </ng-container>
    <ng-container *ngIf="!hasTestKit">
      <span [innerHtml]="t('info/banner/isophi')"></span>
      <span class="link" [innerHTML]="t('info/banner/isophiLink')"></span>
    </ng-container>
  </div>
  <!-- License expiring -->
  <div class="type-wrapper license-expiring" *ngIf="type === 'license-expiring'">
    <i class="material-symbols-rounded filled">alarm</i>
    <span [innerHtml]="t('infoBanner/licenseExpiresIn', { daysLeft, section: t('infoBanner/sectionDiagnostics') })"></span>
    <span *ngIf="canRenew; else teacherInfoExpiring" class="link" (click)="handleRedirectToPriceList()">{{
      t('infoBanner/renewLicense')
    }}</span>
    <ng-template #teacherInfoExpiring>
      <span>{{ t('infoBanner/contactDirectorOrAdmin') }}</span>
    </ng-template>
  </div>
  <!-- Trial expired -->
  <div class="type-wrapper license-expired" *ngIf="type === 'trial-expired'">
    <i class="material-symbols-rounded filled">warning</i>
    <span [innerHtml]="t('infoBanner/trialExpired', { section: t('infoBanner/sectionDiagnostics') })"></span>
    <span *ngIf="canRenew; else teacherInfoTrialExpired" class="link" (click)="handleRedirectToPriceList()">{{
      t('infoBanner/renewLicense')
    }}</span>
    <ng-template #teacherInfoTrialExpired>
      <span>{{ t('infoBanner/contactDirectorOrAdmin') }}</span>
    </ng-template>
  </div>
  <!-- License expired -->
  <div class="type-wrapper license-expired" *ngIf="type === 'license-expired'">
    <i class="material-symbols-rounded filled">warning</i>
    <span [innerHtml]="t('infoBanner/licenseExpired', { section: t('infoBanner/sectionDiagnostics') })"></span>
    <span *ngIf="canRenew; else teacherInfoExpired" class="link" (click)="handleRedirectToPriceList()">{{
      t('infoBanner/renewLicense')
    }}</span>
    <ng-template #teacherInfoExpired>
      <span>{{ t('infoBanner/contactDirectorOrAdmin') }}</span>
    </ng-template>
  </div>
</div>
